module.exports = __webpack_public_path__ + "static/media/trainingprogram.d6968308.png";